// Drawer — side panel built on MUI Drawer (behavior/a11y) with token styling.
// Hosts the R.I.S.A assistant and side filters. On mobile it spans full width.
import PropTypes from 'prop-types';
import MuiDrawer from '@mui/material/Drawer';
import { CloseIcon } from '../../icons/Icons';
import './drawer.css';

export function Drawer({ open, onClose, side = 'right', title, width = 420, children, footer }) {
  return (
    <MuiDrawer
      anchor={side}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: { className: 'drawer__paper', sx: { width: { xs: '100%', sm: width } } },
        backdrop: { sx: { backgroundColor: 'rgba(10,12,20,0.35)' } },
      }}
    >
      <div className="drawer__inner">
        {title && (
          <header className="drawer__head">
            <h2 className="drawer__title">{title}</h2>
            <button type="button" className="drawer__close" onClick={onClose} aria-label="Close">
              <CloseIcon />
            </button>
          </header>
        )}
        <div className="drawer__body">{children}</div>
        {footer && <footer className="drawer__footer">{footer}</footer>}
      </div>
    </MuiDrawer>
  );
}

Drawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  side: PropTypes.oneOf(['left', 'right']),
  title: PropTypes.node,
  width: PropTypes.number,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default Drawer;
